import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/I18nContext";
import { useTheme } from "../contexts/ThemeContext";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  LayoutDashboard, Users, GraduationCap, BookOpen, CalendarDays, ClipboardCheck,
  ListChecks, Award, Coins, MessageSquare, Megaphone, FileSpreadsheet, Building2,
  Languages, LogOut, Layers, School, FileText, BarChart3, Menu, X, Sparkles, Bell,
  Palette, Settings as SettingsIcon, Bus, UserCircle2, Map, Navigation, Briefcase,
  CalendarOff, AlertTriangle, KeyRound, ShieldCheck, ShoppingBag, ScanLine, Wallet,
  Package, Truck, TrendingUp, QrCode, Calendar as CalendarIcon
} from "lucide-react";
import { Button } from "../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "../components/ui/sheet";
import { hijriString, gregorianString } from "../lib/api";
import QuickActionsFAB from "./QuickActionsFAB";
import NotificationBell from "./NotificationBell";
import MobileBottomNav from "./MobileBottomNav";

const NAV = [
  { to: "/", key: "overview", icon: LayoutDashboard, roles: "*" },
  { to: "/my-route", key: "my_route", icon: Navigation, roles: ["driver"] },
  { to: "/schools", key: "schools", icon: Building2, roles: ["super_admin"] },
  { to: "/grades", key: "grades", icon: Layers, roles: ["super_admin", "school_admin", "academic"] },
  { to: "/classes", key: "classes", icon: School, roles: ["super_admin", "school_admin", "academic"] },
  { to: "/subjects", key: "subjects", icon: BookOpen, roles: ["super_admin", "school_admin", "academic"] },
  { to: "/students", key: "students", icon: GraduationCap, roles: ["super_admin", "school_admin", "academic", "teacher"] },
  // Bulk Import group
  { groupKey: "bulk_import", roles: ["super_admin", "school_admin", "academic", "hr"] },
  { to: "/import/students", key: "import_students", icon: FileSpreadsheet, roles: ["super_admin", "school_admin", "academic", "hr"] },
  { to: "/import/employees", key: "import_employees", icon: FileSpreadsheet, roles: ["super_admin", "school_admin", "hr"] },
  { to: "/parents", key: "parents", icon: Users, roles: ["super_admin", "school_admin", "academic", "hr"] },
  { to: "/teachers", key: "teachers", icon: Users, roles: ["super_admin", "school_admin", "academic"] },
  { to: "/timetable", key: "timetable", icon: CalendarDays, roles: ["super_admin", "school_admin", "academic", "teacher", "parent", "student"] },
  { to: "/attendance", key: "attendance", icon: ClipboardCheck, roles: ["super_admin", "school_admin", "academic", "teacher", "parent", "student"] },
  { to: "/grades-entry", key: "gradesEntry", icon: ListChecks, roles: ["super_admin", "school_admin", "academic", "teacher"] },
  { to: "/report-card", key: "reportCard", icon: FileText, roles: ["super_admin", "school_admin", "academic", "teacher", "parent", "student"] },
  { to: "/behavior", key: "behavior", icon: Award, roles: ["super_admin", "school_admin", "academic", "teacher", "parent", "student"] },
  { to: "/fees", key: "fees", icon: Coins, roles: ["super_admin", "school_admin", "finance", "parent"] },
  { to: "/messages", key: "messages", icon: MessageSquare, roles: ["super_admin", "school_admin", "academic", "finance", "teacher", "parent"] },
  { to: "/announcements", key: "announcements", icon: Megaphone, roles: ["super_admin", "school_admin", "academic", "finance", "teacher", "parent", "student", "driver"] },
  { to: "/homework", key: "homework", icon: FileSpreadsheet, roles: ["super_admin", "school_admin", "academic", "teacher", "parent", "student"] },
  { to: "/quizzes", key: "quizzes", icon: ClipboardCheck, roles: ["super_admin", "school_admin", "academic", "teacher", "parent", "student"] },
  // Transport group
  { groupKey: "transport", roles: ["super_admin", "school_admin", "academic"] },
  { to: "/transport/vehicles", key: "vehicles", icon: Bus, roles: ["super_admin", "school_admin", "academic"] },
  { to: "/transport/drivers", key: "drivers", icon: UserCircle2, roles: ["super_admin", "school_admin", "academic"] },
  { to: "/transport/routes", key: "routes", icon: Map, roles: ["super_admin", "school_admin", "academic"] },
  { to: "/transport/assignments", key: "transport_assignments", icon: Users, roles: ["super_admin", "school_admin", "academic"] },
  { to: "/transport/trips", key: "trips", icon: CalendarDays, roles: ["super_admin", "school_admin", "academic"] },
  { to: "/transport/reports", key: "transport_reports", icon: BarChart3, roles: ["super_admin", "school_admin", "academic", "finance"] },
  // Canteen group
  { groupKey: "canteen", roles: ["super_admin", "school_admin", "school_staff", "parent", "finance", "canteen_staff", "student"] },
  { to: "/canteen", key: "canteen_dashboard", icon: ShoppingBag, roles: ["super_admin", "school_admin", "finance"] },
  { to: "/canteen?tab=products", key: "canteen_products", icon: Package, roles: ["super_admin", "school_admin"] },
  { to: "/canteen?tab=suppliers", key: "canteen_suppliers", icon: Truck, roles: ["super_admin", "school_admin"] },
  { to: "/canteen?tab=reports", key: "canteen_reports", icon: TrendingUp, roles: ["super_admin", "school_admin", "finance"] },
  { to: "/canteen?tab=topups", key: "canteen_parent_topups", icon: Wallet, roles: ["super_admin", "school_admin", "finance"] },
  { to: "/canteen?tab=cashflow", key: "canteen_cash_flow", icon: CalendarIcon, roles: ["super_admin", "school_admin", "finance"] },
  { to: "/canteen?tab=settings", key: "canteen_settings", icon: SettingsIcon, roles: ["super_admin", "school_admin"] },
  { to: "/canteen/pos", key: "canteen_pos", icon: ScanLine, roles: ["super_admin", "school_admin", "school_staff", "canteen_staff"] },
  { to: "/canteen/wallet", key: "canteen_wallet", icon: Wallet, roles: ["parent"] },
  { to: "/canteen/my-wallet", key: "canteen_my_wallet", icon: QrCode, roles: ["student"] },
  // HR group
  { groupKey: "hr", roles: ["super_admin", "school_admin", "hr", "finance"] },
  { to: "/hr", key: "hr_dashboard", icon: LayoutDashboard, roles: ["super_admin", "school_admin", "hr", "finance"] },
  { to: "/hr/employees", key: "employees", icon: Briefcase, roles: ["super_admin", "school_admin", "hr", "finance", "academic"] },
  { to: "/hr/attendance-today", key: "hr_today_attendance", icon: ClipboardCheck, roles: ["super_admin", "school_admin", "hr", "finance", "academic"] },
  { to: "/hr/payroll-report", key: "hr_payroll_report", icon: FileText, roles: ["super_admin", "school_admin", "hr", "finance"] },
  { to: "/hr/departments", key: "manage_departments", icon: Layers, roles: ["super_admin", "school_admin", "hr"] },
  { to: "/hr/leaves", key: "leaves", icon: CalendarOff, roles: ["super_admin", "school_admin", "hr"] },
  { to: "/hr/payroll", key: "payroll", icon: Coins, roles: ["super_admin", "school_admin", "hr", "finance"] },
  { to: "/hr/recruitment", key: "recruitment", icon: Users, roles: ["super_admin", "school_admin", "hr"] },
  { to: "/hr/users", key: "user_accounts", icon: KeyRound, roles: ["super_admin", "school_admin", "hr"] },
  // System
  { to: "/reports", key: "reports", icon: BarChart3, roles: ["super_admin", "school_admin", "academic", "finance"] },
  { to: "/ai", key: "ai_assistant", icon: Sparkles, roles: ["super_admin", "school_admin", "academic", "teacher"] },
  { to: "/notifications", key: "notifications", icon: Bell, roles: ["super_admin", "school_admin", "academic", "finance"] },
  { to: "/audit-logs", key: "audit_logs", icon: ShieldCheck, roles: ["super_admin", "school_admin"] },
  { to: "/help", key: "help_docs", icon: BookOpen, roles: ["super_admin", "school_admin", "academic", "hr", "finance", "teacher", "parent", "student", "canteen_staff"] },
  { to: "/settings", key: "settings", icon: SettingsIcon, roles: ["super_admin"] },
];

function SidebarContent({ user, onNavigate, testIdSuffix = "" }) {
  const { t, lang, setLang, langs } = useI18n();
  const { theme, setTheme, themes } = useTheme();
  const { logout } = useAuth();
  const nav = useNavigate();
  const allowed = NAV.filter((n) => n.roles === "*" || n.roles.includes(user.role));

  return (
    <div className="h-full flex flex-col">
      <div className="p-5 border-b border-border">
        <Link to="/" onClick={onNavigate} className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-primary text-primary-foreground grid place-items-center font-bold text-xs">SI</div>
          <div className="min-w-0">
            <div className="font-semibold text-foreground leading-tight truncate">{t("appName")}</div>
            <div className="text-xs text-muted-foreground truncate">{t("tagline")}</div>
          </div>
        </Link>
      </div>
      <nav className="flex-1 overflow-y-auto p-3 space-y-1">
        {allowed.map((it) => {
          if (it.groupKey) {
            return (
              <div key={it.groupKey} className="pt-3 pb-1 px-3 text-[10px] uppercase tracking-wider font-semibold text-muted-foreground/70 border-t border-border/60 mt-2">
                {t(it.groupKey)}
              </div>
            );
          }
          return (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.to === "/"}
              data-testid={`nav-${it.key}${testIdSuffix}`}
              onClick={onNavigate}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-lg text-sm smooth ${
                  isActive ? "bg-primary text-primary-foreground" : "text-foreground hover:bg-muted"
                }`
              }
            >
              <it.icon className="w-4 h-4 shrink-0" />
              <span className="truncate">{t(it.key)}</span>
            </NavLink>
          );
        })}
      </nav>
      <div className="p-3 border-t border-border space-y-2">
        <Select value={lang} onValueChange={setLang}>
          <SelectTrigger className="w-full" data-testid={`lang-select${testIdSuffix}`}>
            <Languages className="w-4 h-4 me-2 shrink-0" />
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {langs.map((l) => (
              <SelectItem key={l.code} value={l.code} data-testid={`lang-${l.code}${testIdSuffix}`}>{l.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select value={theme} onValueChange={setTheme}>
          <SelectTrigger className="w-full" data-testid={`theme-select${testIdSuffix}`}>
            <Palette className="w-4 h-4 me-2 shrink-0" />
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {Object.entries(themes).map(([key, val]) => (
              <SelectItem key={key} value={key} data-testid={`theme-${key}${testIdSuffix}`}>
                <span className="flex items-center gap-2">
                  <span className="inline-block w-3 h-3 rounded-full border border-border" style={{ background: `hsl(${val.vars["--primary"]})` }} />
                  {lang === "ar" ? (val.label_ar || val.label) : val.label}
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Button
          variant="ghost"
          className="w-full justify-start gap-2 text-destructive"
          onClick={async () => { await logout(); nav("/login"); }}
          data-testid={`logout-btn${testIdSuffix}`}
        >
          <LogOut className="w-4 h-4 lucide-rotate-rtl" />
          {t("logout")}
        </Button>
      </div>
    </div>
  );
}

export default function AppLayout({ children }) {
  const { user } = useAuth();
  const { t, lang, dir } = useI18n();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background flex">
      {/* Desktop Sidebar */}
      <aside className="hidden lg:flex w-64 shrink-0 border-e border-border bg-card flex-col" data-testid="app-sidebar">
        <SidebarContent user={user} onNavigate={() => {}} />
      </aside>

      {/* Mobile Sidebar */}
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side={dir === "rtl" ? "right" : "left"} className="w-72 p-0">
          <SheetTitle className="sr-only">{t("appName")}</SheetTitle>
          <SheetDescription className="sr-only">{t("tagline")}</SheetDescription>
          <SidebarContent user={user} onNavigate={() => setOpen(false)} testIdSuffix="-mobile" />
        </SheetContent>
      </Sheet>

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="relative z-40 h-16 border-b border-border bg-card/60 backdrop-blur flex items-center justify-between px-4 sm:px-6 gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <Button
              variant="ghost"
              size="icon"
              className="lg:hidden"
              onClick={() => setOpen(true)}
              data-testid="mobile-menu-btn"
              aria-label="menu"
            >
              <Menu className="w-5 h-5" />
            </Button>
            <div className="min-w-0">
              <div className="text-sm font-medium truncate">{t("welcome")}{lang === "ar" ? "،" : ","} {user.name}</div>
              <div className="text-xs text-muted-foreground truncate">{t(user.role)}</div>
            </div>
          </div>
          <div className="hidden md:flex items-center gap-6 text-end">
            <div>
              <div className="text-xs text-muted-foreground">{t("todayHijri")}</div>
              <div className="text-sm font-medium font-mono">{hijriString()}</div>
            </div>
            <div>
              <div className="text-xs text-muted-foreground">{t("todayGreg")}</div>
              <div className="text-sm font-medium font-mono">{gregorianString(new Date(), lang === "ar" ? "ar-SA" : "en-GB")}</div>
            </div>
          </div>
          {/* Single NotificationBell mount — visible on both desktop & mobile via CSS */}
          <NotificationBell />
        </header>
        <main className="flex-1 p-4 sm:p-6 md:p-8 overflow-x-hidden animate-fade-up mb-nav lg:mb-0">{children}</main>
      </div>
      <QuickActionsFAB />
      <MobileBottomNav onOpenMenu={() => setOpen(true)} />
    </div>
  );
}
